import { Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Alert } from '@/shared/components/ui/alert/alert';
import { ConfirmDelete } from '@/shared/components/ui/confirm-delete/confirm-delete';
import { Can } from '@/shared/features/permissions/components/can/can';
import { TDeleteUserProps } from '@/shared/features/rbac/components/delete-user/delete-user.types';
import { useDeleteUserMutation } from '@/shared/redux/api/ident/ident-api';
import {
  DeleteUserMutation,
  UserSourceEnum,
} from '@/shared/types/types.generated';

export const DeleteUser: React.FC<TDeleteUserProps> = ({
  userIds,
  userSource,
  ...rest
}) => {
  const { t } = useTranslation();
  const [deleteUserMutation] = useDeleteUserMutation();

  const count = userIds.length;

  const deleteUser = async () => {
    const promises: Promise<DeleteUserMutation>[] = [];

    userIds.forEach((userId) => {
      promises.push(deleteUserMutation({ userId }).unwrap());
    });
    await Promise.all(promises);
  };

  const getDeleteUserWarning = () => {
    if (userSource && userSource !== UserSourceEnum.Sda) {
      return (
        <Stack gap="1rem">
          <Alert color="red" text={t('rbac:user_delete_warning', { count })} />
          <Alert color="yellow" text={t('rbac:user_delete_saml_warning')} />
        </Stack>
      );
    }

    return (
      <Alert color="red" text={t('rbac:user_delete_warning', { count })} />
    );
  };

  return (
    <Can action="backofficeUser:deleteUser" ids={userIds}>
      <ConfirmDelete
        deleteMutation={deleteUser}
        itemCount={count}
        deleteWarning={getDeleteUserWarning()}
        {...rest}
      />
    </Can>
  );
};
